import React, { useEffect, useState } from "react";

import PanelTemplate from "../../templates/Panel";
import Table from "../../components/Table";
import Box from "../../components/Box";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import moment from "moment";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import FilterSimple from "../../components/FilterSimple";
import { toast } from "react-toastify";
import { Loading } from "../../components/Loading";
import { ModalDelete } from "../../components/ModalDelete";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import PasswordChecklist from "../../components/PasswordChecklist";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import { getUser } from "../../services/auth";

const Userlist = () => {

    const [data, setData] = useState({header: [], rows: []});
    const [supplierUsers, setSupplierUsers] = useState([]);
    const [supplier, setSupplier] = useState([]);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [updatePassword, setUpdatePassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isValidPassword, setIsValidPassword] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);


    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);

    useEffect(() => {
        getSupplierUser();        
    }, [])

    useEffect(() => {
        generateData();
    }, [supplierUsers])

    const generateData = () => {
        let header = ['Nome', 'E-mail', 'Criado em'];
        const rows = [];

        supplierUsers.map(supplier => {
            rows.push({
                data: [
                    supplier.name,
                    supplier.email,
                    supplier.created_at ? moment(supplier.created_at).format('DD/MM/YYYY HH:mm') : '',
                ],
                action: () => handleEdit(supplier),
                id: supplier.id,
            })
        });

        setData({header, rows});
    }

    const handleEdit = (supplierUser) => {
        setSelectedUser(supplierUser);
        setName(supplierUser.name);
        setEmail(supplierUser.email);
        setShowEdit(true);
    };

    const handleClose = () => {
        if (showCreate) {
            setShowCreate(false)
        }else{
            setShowEdit(false)
        }
        setSelectedUser([]);
        setName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setUpdatePassword(false);
    }

    const updateContact = () => {
        setLoading(true);
        api.put(`/user/${selectedUser.id}`, {      
            name,
            email,      
            password, 
            password_confirmation: confirmPassword,
        }).then(res => {
            toast.success('Usuário atualizada com sucesso');
            getSupplierUser();
            handleClose();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const storeSupplierUser = () => {
        setLoading(true);
        api.post(`/user`, {
            name,
            email,       
            password, 
            password_confirmation: confirmPassword,
        }).then(res => {
            toast.success('Usuário salvo com sucesso');
            getSupplierUser();
            handleClose();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const getSupplierUser = () => {
        api.get(`/user`).then(res => {
            let resource = res.data.resource;            
            
            setSupplierUsers(resource);           
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const deleteMultipleSuppliers = () => {
        setLoading(true);

        api.delete(`/user/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getSupplierUser();
            setShowConfirmMultipleDelete(false);
            toast.success('Usuário deletado com sucesso');
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const handleCriteriaChange = (criteria) => {
        const allValid = Object.values(criteria).every(Boolean);
        setIsValidPassword(allValid);
    };

    return (
        <>
        <PanelTemplate>
            <Loading show={loading} />
            {!loading && <Box> 
                <ModalDelete
                            show={showConfirmMultipleDelete}
                            text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'usuários' : 'usuário'}</strong>?</p>}
                            action={deleteMultipleSuppliers}
                            loading={loading}
                            close={() => setShowConfirmMultipleDelete(false)}
                        />
                <Modal
                    title={`${showCreate ? 'Cadastrar' : 'Editar'} usuário`}
                    show={showCreate || showEdit}
                    close={handleClose}
                    footer={
                        <>
                            {((!updatePassword) || (updatePassword && isValidPassword)) && (
                                <Button 
                                    type="primary"
                                    size="small"
                                    text={showCreate ? 'Cadastrar' : 'Salvar alterações'}
                                    svg={`save-white`}
                                    action={() => showCreate ? storeSupplierUser() : updateContact()}
                                    loading={loading}
                                />
                            )}
                            
                        </>
                    }
                >
                    <div className="section">
                        <div className="row">
                            <div className="col-6">
                                <Input type={`text`} label={`Nome`} value={name} change={setName} autoComplete={`new-password`} />
                            </div>
                            <div className="col-6">
                                <Input type={`email`} label={`E-mail`} value={email} change={setEmail} autoComplete={`new-password`} />
                            </div>
                        </div>
                        {showEdit &&
                            <InputCheckboxUnique label={`Alterar senha`} checked={updatePassword} change={setUpdatePassword} />
                        }
                        {(showCreate || updatePassword) &&
                                <div className="row">
                                    <div className="col-6">
                                        <Input type={`password`} label={`Senha`} value={password} change={setPassword} autoComplete={`new-password`} />
                                        <PasswordChecklist password={password} confirmPassword={confirmPassword} onCriteriaChange={handleCriteriaChange}/>
                                        <br />
                                    </div>
                                    <div className="col-6">
                                        <Input type={`password`} label={`Confirme a senha`} change={setConfirmPassword} value={confirmPassword} />
                                    </div>
                                </div>
                        }
                    </div>
                </Modal>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Button 
                            type="secondary" 
                            size="small" 
                            text="Adicionar usuário" 
                            svg="plus-blue" 
                            action={() => setShowCreate(true)} 
                        />
                        {selectedIds.length > 0 && (
                            <Button 
                                type="secondary" 
                                size="small" 
                                svg="delete"
                                text={`Excluir ${selectedIds.length} selecionados`} 
                                action={() => setShowConfirmMultipleDelete(true)}  
                                style={{ marginLeft: '8px' }}
                            />
                        )}
                </div>
                <br />
                <Table 
                    header={data.header} 
                    rows={data.rows} 
                    checks={true} 
                    loading={loading} 
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                />
            </Box>
            }
            </PanelTemplate>
        </>
    );
}

export default Userlist;